const normalizeUrlEnv = (value: string | undefined, key: string, fallback: string) => {
  const rawValue = value?.trim();

  if (!rawValue) {
    return fallback;
  }

  const keyPrefix = `${key}=`;
  const normalizedValue = rawValue.startsWith(keyPrefix)
    ? rawValue.slice(keyPrefix.length)
    : rawValue;

  return normalizedValue.replace(/\/$/, '');
};

export const env = {
  API_BASE_URL: normalizeUrlEnv(
    import.meta.env.VITE_API_BASE_URL,
    'VITE_API_BASE_URL',
    'http://localhost:3001'
  ),
  NODE_ENV: import.meta.env.MODE || 'development',
  ENABLE_DEV_TOOLS:
    import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true' || import.meta.env.MODE === 'development',
} as const;
